import { CalendarView } from "../ws7/calendar/CalendarView";
import "../ws7/ws7.css";

/** /calendar?week=YYYY-MM-DD&render=&account=&day=&time=&move=&posted= (WS7). */
export function CalendarPage() {
  return <CalendarView />;
}
